<template>
  <div>
  <v-card
    class="mx-auto my-2"
    max-width="344"
  >
    <v-img style="width: 100%; height: auto"
      :src="image_url"
    ></v-img>

    <v-card-title>
      <div>{{ name }}</div>

    </v-card-title>

  <v-tabs
      background-color="#4caf50"
      class="elevation-2"
      dark
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab
        href="#tab-1"
      >Info</v-tab>

      <v-tab
        href="#tab-2"
      >Chat</v-tab>

      <v-tab
        href="#tab-3"
      >Swap</v-tab>

      <v-tab-item
        value="tab-1"
      >
        <v-card
          flat
          tile
        >
          <v-card-text>
            <span class="grey--text subtitle-1">{{ description }}</span>
          </v-card-text>
        </v-card>
      </v-tab-item>

       <v-tab-item
        value="tab-2"
      >
        <v-card
          flat
          tile
        >
          <v-card-text>

          <div class="my-1 pa-1" style="background: #EDEDED"
            v-for="(item, i) in comments"
            :key="i"
          >
            <div>{{ item.message}}</div>
          </div>

          <v-textarea style="margin-bottom: 10px; margin-top: 10px"
          v-model="commentForm.message"
          :rules="[v => !!v || 'comment can not be empty']"
          outlined
          name="input"
          label="Your Comment"
          value=""
          ></v-textarea>

          <div style="text-align: right; margin-top: -35px; margin-bottom: 8px">
            <v-btn @click="addComment()">Add</v-btn>
          </div>

          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item
        value="tab-3"
      >
        <v-card
          flat
          tile
        >
          <v-card-text>

          <div class="my-1 pa-1" style="background: #EDEDED; overflow: hidden;"
            v-for="(item, i) in swapRequests"
            :key="i"
          >
            <span class="swap_request_excerpt">{{ item.message}}</span>
          </div>

          <div  v-show="ownerAddress != myaddress" style="text-align: center; margin-top: -5px; margin-bottom: 8px">
            <v-btn @click.stop="requestModalOpen = true">Send Request</v-btn>
          </div>

          </v-card-text>
        </v-card>
      </v-tab-item>

    </v-tabs>

  </v-card>

   <!-- Begin Dialog Form -->
  <v-layout justify-center>
    <v-dialog v-model="requestModalOpen" persistent max-width="600px">

      <v-card>
        <v-card-title>
          <span class="headline">Select Your Collectible to Swap</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form
              ref="requestForm"
            >

            <v-select
          v-model="myNFTToSwap"
          :items="mynftlist"
          item-text="name"
          item-value="asset_contract.address + '|' + token_id"
          label="Select"
          persistent-hint
          return-object
          single-line
          ></v-select>

            <div class="text-center">

              <v-btn
                color="success"
                class="mr-4"
                @click="sendSwapRequest()"
              >
                Send Swap Request
              </v-btn>



        </div>



            </v-form>

          </v-container>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="requestModalOpen = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
   <!-- End Dialog Form -->
  </div>
</template>

<script>
import { config } from '@/config'
export default {
  props: ['info', 'myaddress', 'mynftlist'],
  data () {
    return {
      comments: [],
      commentThread: null,
      swapRequests: [],
      swapThread: null,
      commentForm: {
        message: ''
      },
      myNFTToSwap: null,
      requestModalOpen: false,
    }
  },
  computed: {
    // myAddress: function () {
    //   return this.$store.state.userAddress
    // },
    name: function () {
      return this.info.name
    },
    description: function () {
      return this.info.description
    },
    contractAddress: function () {
      return this.info.asset_contract.address
    },
    token_id: function () {
      return this.info.token_id
    },
    ownerAddress: function () {
      return this.info.owner.address
    },
    image_url: function () {
      return this.info.image_url
    },
    appSpace: function () {
      return this.$store.state.appSpace
    },
    // threadNameComment: function () {
    //   return this.contractAddress + '-' + this.token_id
    // },
    // externalURL: function () {
    //   return this.info.permalink
    // },
  },
  methods: {

    async init() {
      console.log(this.mynftlist)
      const threadNameComment = this.contractAddress + '-' + this.token_id
      const threadNameSwap = this.contractAddress + '-' + this.token_id + '-swap-request'
      this.commentThread = await this.appSpace.joinThread(threadNameComment, { firstModerator: this.ownerAddress })
      this.swapThread = await this.appSpace.joinThread(threadNameSwap, { firstModerator: this.ownerAddress })
      this.commentThread.onUpdate(() => this.getComments())
      this.swapThread.onUpdate(() => this.getSwapRequests())
      await this.getComments()
      await this.getSwapRequests()
    },

    async getComments() {
      const comments = await this.commentThread.getPosts()
      const reversed = comments.reverse()
      this.comments = [...reversed]
    },

    async getSwapRequests() {
      const swapRequests = await this.swapThread.getPosts()
      const reversed = swapRequests.reverse()
      this.swapRequests = [...reversed]
    },

    async addComment() {
      const threadNameComment = this.contractAddress + '-' + this.token_id
      // this.commentThread = await this.appSpace.joinThread(threadNameComment)
      const message = this.commentForm.message
      await this.commentThread.post(message)
      this.init()
    },

    async sendSwapRequest()  {
      const threadNameSwap = this.contractAddress + '-' + this.token_id + '-swap-request'
      // this.commentThread = await this.appSpace.joinThread(threadNameComment)
      const message = this.myNFTToSwap
      await this.swapThread.post(message)
      this.init()
    }

  },
  created () {
    this.init()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.swap_request_excerpt {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}
.v-tab {
    margin-left: 0px !important;
}
</style>
